import { Fab } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ActionButton = styled(Fab)(({ theme }) => ({
  borderRadius: 0,
  padding: '8px',
  backgroundColor: theme.palette.common.white,
  boxShadow: 'none',
  '&.Mui-disabled': {
    opacity: 0.3,
    backgroundColor: theme.palette.common.white
  }
}));
